import { LANGUAGES, currentLocale, setLocale, t } from '../i18n';

/**
 * Globe + native-language select. `compact` shows only the code (header); the footer shows
 * the native name. Language names are never translated.
 */
export function LanguageSwitch({ compact = false }: { compact?: boolean }) {
  const current = currentLocale();
  const id = compact ? 'cv-lang-compact' : 'cv-lang';
  return (
    <label class={`cv-switch${compact ? ' compact' : ''}`} title={t('app.language')}>
      <span class="sr-only">{t('app.language')}</span>
      <svg class="ic" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="9.5" />
        <path d="M2.5 12h19M12 2.5c3 3.2 4.5 6.4 4.5 9.5s-1.5 6.3-4.5 9.5c-3-3.2-4.5-6.4-4.5-9.5S9 5.7 12 2.5z" />
      </svg>
      <select
        id={id}
        aria-label={t('app.language')}
        value={current}
        onChange={(e) => void setLocale((e.currentTarget as HTMLSelectElement).value, true)}
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code} lang={l.code} dir={l.dir}>
            {l.name}
          </option>
        ))}
      </select>
      {compact && (
        <span class="val" aria-hidden="true">
          {current.split('-')[0].toUpperCase()}
        </span>
      )}
    </label>
  );
}
